import { ActivitiesReducerState } from './types';

export const initialState: ActivitiesReducerState = {
  list: null,
  total: null,
  starredPresent: false,
  appliedFilters: {},
  // @ts-ignore
  detailsTargetActivity: null,
  activityDetailsData: null,
  taskStatuses: [
    { documentType: 0, status: 0, rejectedReason: null, rejectionDate: null },
    { documentType: 1, status: 0, rejectedReason: null, rejectionDate: null },
    { documentType: 2, status: 0, rejectedReason: null, rejectionDate: null },
  ],
  availableInstallDates: {
    firstAvailableDate: `${new Date().toString()}`,
    excludeDates: [''],
    enableWeekends: false,
  },
  availableDeliveryDates: {
    firstAvailableDate: `${new Date().toString()}`,
    excludeDates: [''],
    enableWeekends: false,
  },
};

export const mockActivityInstances = {
  order: {
    equipmentPrice: 1000,
    productName: 'productName',
    orderDetails: {
      deliveryType: 1,
    },
    additionalContact: {
      contactType: 1,
      firstName: 'firstName',
    },
    shipmentContact: {
      firstName: 'firstName',
    },
    salesRepresentative: {
      firstName: 'firstName',
    },
    isDistribution: false,
  },
};

export const mockExpectedState = {
  total: 5,
  starredPresent: false,
  activityDetailsData: {
    fromOpportunity: false,
    activityId: undefined,
    activityType: 0,
    messageBoardId: undefined,
    orderInfo: {
      ...mockActivityInstances.order,
    },
    isDistribution: false,
    fullName: 'firstName',
    contact: { firstName: 'firstName' },
    salesRepresentative: { fullName: 'firstName' },
    salesforceBucketId: '',
    siteSurveyAsServiceInfo: null,
    priceBreakdown: {
      items: [
        {
          code: 'EquipmentPrice',
          title: 'productName',
          type: 'Product',
          price: 1000,
        },
      ],
      tax: 0,
    },
    shippingAddress: {
      creationDate: 'Invalid Date',
      deliveryType: 1,
      name: 'firstName',
      phone: null,
      email: null,
      address: '',
    },
    additionalContactInfo: { contactType: 1, name: 'firstName', phone: undefined },
    deliveryInstruction: '',
    photoAlbumLink: '',
    bucketId: undefined,
    attachments: [],
    orderItems: [],
  },
};
